import { render, staticRenderFns } from "./CloserButton.vue?vue&type=template&id=16fc8ca4&"
import script from "./CloserButton.vue?vue&type=script&lang=js&"
export * from "./CloserButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports